import Breadcrumbs from './Breadcrumbs';

export default Breadcrumbs;



// WEBPACK FOOTER //
// ./src/components/shared/Breadcrumbs/index.js